module.exports = __webpack_public_path__ + "static/media/sendIcon.dbbf6e58.webp";